import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'rr' })
export class RrPipe implements PipeTransform {
  transform(input: number, ww: number, unit: string = 'mm'): any {
    if (!input) {
      return '--';
    }
    if (unit === 'mm') {
      if (input === 0.0 || input === 0) {
        return '--';
      } else if (input <= 0.05 && ww >= 50) {
        return '<0.1';
      } else if (input <= 0.05) {
        return '<0.1';
      } else if (input < 0.1) {
        return '0.1';
      } else {
        return input.toFixed(1);
      }
    } else if (unit === 'in') {
      if (input === 0.0 || input === 0) {
        return '--';
      } else if (input <= 0.005 && ww >= 50) {
        return '<0.01';
      } else if (input <= 0.005) {
        return '<0.01';
      } else if (input < 0.01) {
        return '0.01';
      } else {
        return input.toFixed(2);
      }
    }
  }
}
